require('lodash')

const subdomainRedirects = {
  "mtg": "mortgage",
  "ff": "focusfire",
  "public-proxy": "focusfire",
}

export default function handleSubdomainRedirect() {
  const subdomain = window.location.host && window.location.host.split('.')[0]
  if (_.has(subdomainRedirects, subdomain)) {
    window.location.replace(window.location.href.replace(subdomain, subdomainRedirects[subdomain]))
    return true
  }
  return false
}
